import { z } from 'zod';

import { PushNotificationConfigSchema } from './push-notification-config.schema';
import { SmsNotificationConfigSchema } from './sms-notification-config.schema';

export const EngagementChannelConfigSchema = z
  .object({
    pushNotificationConfig: PushNotificationConfigSchema.optional(),
    smsConfig: SmsNotificationConfigSchema.optional(),
  })
  .refine(
    (data) => {
      const pushEnabled = data?.pushNotificationConfig?.isEnabled ?? false;
      const smsEnabled = data?.smsConfig?.isEnabled ?? false;

      return pushEnabled || smsEnabled;
    },
    {
      message: 'At least one notification channel must be enabled',
      path: ['root'],
    },
  );

export type EngagementChannelConfig = z.infer<typeof EngagementChannelConfigSchema>;
export type EngagementChannelConfigFormValues = EngagementChannelConfig;
export type EngagementChannel = 'sms' | 'push';
